import colors from '../colors';
import * as React from 'react';
import styled, { css, StyledFunction } from 'styled-components';
import { Link } from '../../typedefs/store';
import ChoiceButtonList from './ChoiceButtonList';
import AnonymousAvatar from './AnonymousAvatar';
import LinkIcon from './LinkIcon';

interface Props {
    link: Link;
}

const Link: React.SFC<Props> = ({ link }) => (
    <Wrapper className="conversations-link-item">
        <IconWrapper>
            <LinkIcon icon={link.icon} />
        </IconWrapper>
        <LinkEl className="conversations-link" href={link.url}>{link.text}</LinkEl>
    </Wrapper>
);

export default Link;

const Wrapper = styled.div`
    display: flex;
    font-size: 1.1em;
    margin: 10px 0;
    align-items: center;
    &:last-child {
        margin-bottom: 0;
    }
`;

const IconWrapper = styled.div`
    width: 36px;
    flex-grow: 0;
    flex-shrink: 0;
`;

const LinkEl = styled.a`
    display: block;
    color: ${colors.blue};
    text-decoration: none;
    flex-grow: 1;
    &:hover,
    &:active,
    &:focus {
        color: ${colors.blue};
        text-decoration: underline;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Link.tsx